import React,{ useState } from 'react'
import styled from 'styled-components'
import { PopupCancelCashout } from './PopupCancelCashout'
import '../Payments/shared/payments.css'

export const CancellTrigger = ({ cashout, closeAfterCancel, index = 0 }) => {
  const [showConfirm, setShowConfirm] = useState(false)

  const show = () => {
    setShowConfirm(true)
  }

  const onClose = () => {
    setShowConfirm(false)
  }

  // Show red button for index 1 (second item), others as text links
  const isRedButton = index === 1

  return (
    <>
      <PopupCancelCashout
        onClose={onClose}
        show={showConfirm}
        title='Cancelar Retiro'
        cashout={cashout}
        closeAfterCancel={closeAfterCancel}
      />

      {cashout.status === 'pending' && (
        isRedButton ? (
          <ButtonRed onClick={show} className='payment-button--danger' style={{ padding: '6px 16px', fontSize: '14px' }}>
            Cancelar
          </ButtonRed>
        ) : (
          <ButtonLink onClick={show}>Cancelar</ButtonLink>
        )
      )}
    </>
  )
}

const ButtonRed = styled.button`
  border: none;
  outline: none;
  cursor: pointer;
`

const ButtonLink = styled.button`
  background: transparent;
  border: none;
  color: #ffffff;
  cursor: pointer;
  padding: 0;
  font-size: 13px;
  text-decoration: none;
  padding: 4px 14px;
  border-radius: 15px;
  background-color: #7f0101;
  border: 2px solid #7f0101;

  &:hover {
    background-color: #7f0101;
    border: 2px solid #d11818;
  }
`